import ProseMirrorEditor from './ProseMirrorEditor.vue'

export default ProseMirrorEditor;
